import { TabsContent } from '@/components/ui/tabs';

import { PayrollEmployeeDirectorySection } from '@/components/payroll/PayrollEmployeeDirectorySection';
import { PayrollEmployeesToolbar } from '@/components/payroll/PayrollEmployeesToolbar';

export const PayrollEmployeesTabContent = ({
  employeeDirectory,
  activeEmployeeFiltersCount,
  employeeSearchQuery,
  onEmployeeSearchChange,
  employeeStatusFilter,
  onEmployeeStatusChange,
  employeeSortField,
  onEmployeeSortFieldChange,
  employeeSortDirection,
  onEmployeeSortDirectionChange,
  employeeSortOptions,
  onClearFilters,
  sortedEmployees,
  selectedEmployeeIds,
  allVisibleEmployeesSelected,
  canManagePayroll,
  openPayrollEmployeeDialog,
  toggleAllVisibleEmployees,
  handleBulkProcessEmployees,
  toggleEmployeeSelection,
  openDossierDialog,
}) => (
  <TabsContent value="employees" className="space-y-4" data-testid="payroll-employees-tab-content">
    <PayrollEmployeesToolbar
      employeeDirectory={employeeDirectory}
      activeEmployeeFiltersCount={activeEmployeeFiltersCount}
      employeeStatusFilter={employeeStatusFilter}
      onEmployeeStatusChange={onEmployeeStatusChange}
      employeeSortField={employeeSortField}
      onEmployeeSortFieldChange={onEmployeeSortFieldChange}
      employeeSortDirection={employeeSortDirection}
      onEmployeeSortDirectionChange={onEmployeeSortDirectionChange}
      employeeSortOptions={employeeSortOptions}
      onClearFilters={onClearFilters}
    />

    <PayrollEmployeeDirectorySection
      sortedEmployees={sortedEmployees}
      employeeSortField={employeeSortField}
      employeeSortDirection={employeeSortDirection}
      employeeSortOptions={employeeSortOptions}
      employeeDirectory={employeeDirectory}
      selectedEmployeeIds={selectedEmployeeIds}
      allVisibleEmployeesSelected={allVisibleEmployeesSelected}
      canManagePayroll={canManagePayroll}
      openPayrollEmployeeDialog={openPayrollEmployeeDialog}
      toggleAllVisibleEmployees={toggleAllVisibleEmployees}
      handleBulkProcessEmployees={handleBulkProcessEmployees}
      toggleEmployeeSelection={toggleEmployeeSelection}
      openDossierDialog={openDossierDialog}
      employeeSearchQuery={employeeSearchQuery}
      onEmployeeSearchChange={onEmployeeSearchChange}
    />
  </TabsContent>
);